import {Cell, Row} from 'exceljs';
import {
    defaultFont,
    defaultLinkFont,
    defaultSheetTitleFont,
    defaultTableHeaderFont,
} from 'src/modules/downloads/cells/fonts';
import {
    HorizontalAlignment,
    VerticalAlignment,
    createTableCellStyle,
    createTableHeaderStyle,
} from 'src/modules/downloads/cells/styles';
import {setColumnWidth} from 'src/modules/downloads/utils/set-column-width';

export const EXCEL_CELL_MAX_LENGTH = 32767;
export const CRITERIA_EXCEPTION_MESSAGE = 'Criteria is not displayed according to the Excel cell limit';

export const decorateCell = (
    cell: Partial<Cell>,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    cell.font = defaultFont;
    return cellDecorator ? cellDecorator(cell) : cell;
};

export const decorateLinkCell = (
    cell: Partial<Cell>,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    cell.font = defaultLinkFont;
    cell.alignment = {vertical: VerticalAlignment.MIDDLE};
    return cellDecorator ? cellDecorator(cell) : cell;
};

export const decorateTableHeaderCell = (
    cell: Partial<Cell>,
    width: number,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    cell.style = createTableHeaderStyle;
    cell.font = defaultTableHeaderFont;
    setColumnWidth(cell, width);

    return cellDecorator ? cellDecorator(cell) : cell;
};

export const decorateTableCell = (
    row: Row,
    cellNumber: number,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    const cell = row.getCell(cellNumber) as Partial<Cell>;
    cell.style = createTableCellStyle(row.number);
    cell.font = defaultFont;

    return cellDecorator ? cellDecorator(cell) : cell;
};

export const decorateLinkTableCell = (
    row: Row,
    cellNumber: number,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    const cell = row.getCell(cellNumber) as Partial<Cell>;
    cell.style = createTableCellStyle(row.number);
    cell.font = defaultLinkFont;
    cell.alignment = {vertical: VerticalAlignment.MIDDLE};

    return cellDecorator ? cellDecorator(cell) : cell;
};

export const decorateSheetTitleCell = (
    cell: Partial<Cell>,
    cellDecorator?: (cell: Partial<Cell>) => Partial<Cell>,
) => {
    cell.font = defaultSheetTitleFont;
    cell.alignment = {horizontal: HorizontalAlignment.CENTER};

    return cellDecorator ? cellDecorator(cell) : cell;
};

export const setCellValue = (
    value: string,
    horizontalAlignment: HorizontalAlignment = HorizontalAlignment.LEFT,
    verticalAlignment: VerticalAlignment = VerticalAlignment.MIDDLE,
) => (cell: Partial<Cell>) => {
    cell.alignment = {horizontal: horizontalAlignment, vertical: verticalAlignment};
    cell.value = value;
    return cell;
};
